import React, { useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import { toast, Toaster } from "sonner";
import { ArrowRight, EnvelopeSimple } from "@phosphor-icons/react";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      const detail = err?.response?.data?.detail;
      toast.error(typeof detail === "string" ? detail : "Could not send reset email. Please try again.");
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen grid grid-cols-1 md:grid-cols-2" style={{ background: "var(--bg)" }} data-testid="forgot-password-page">
      <Toaster theme="dark" />
      <div className="hidden md:block relative grid-bg border-r" style={{ borderColor: "var(--border)" }}>
        <div className="absolute inset-0 p-12 flex flex-col justify-between">
          <Link to="/" className="font-display font-black text-2xl tracking-tighter">
            MY NEXUS<span style={{ color: "var(--accent)" }}> </span>CARD
          </Link>
          <div>
            <div className="overline mb-3">// reset password</div>
            <h2 className="font-display font-black text-5xl tracking-tighter leading-none">
              Forgot it.<br />No problem.
            </h2>
          </div>
        </div>
      </div>
      <div className="flex items-center justify-center p-8">
        {sent ? (
          <div className="w-full max-w-md text-center" data-testid="reset-sent">
            <EnvelopeSimple size={64} weight="duotone" color="var(--accent)" className="mx-auto" />
            <div className="overline mt-6 mb-2" style={{ color: "var(--accent)" }}>// email sent</div>
            <h1 className="font-display font-black text-3xl tracking-tighter">Check your inbox.</h1>
            <p className="mt-4" style={{ color: "var(--text-2)" }}>If an account exists for <strong style={{ color: "var(--text)" }}>{email}</strong>, we've sent a password reset link. It expires in 1 hour.</p>
            <Link to="/login" className="btn-secondary mt-8 inline-flex items-center gap-2">← Back to sign in</Link>
          </div>
        ) : (
          <form onSubmit={submit} className="w-full max-w-md" data-testid="forgot-form">
            <div className="overline mb-4">// reset password</div>
            <h1 className="font-display font-black text-4xl tracking-tighter mb-4">Reset your password.</h1>
            <p className="mb-8" style={{ color: "var(--text-2)" }}>Enter your account email. We'll send you a link to set a new password.</p>

            <label className="label-base">Email</label>
            <input data-testid="forgot-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="input-base mb-8" autoComplete="email" />

            <button type="submit" disabled={busy || !email} data-testid="forgot-submit" className="btn-primary w-full flex items-center justify-between">
              {busy ? "Sending..." : "Send reset link"} <ArrowRight weight="bold" />
            </button>

            <p className="mt-8 text-sm" style={{ color: "var(--text-2)" }}>
              Remembered it? <Link to="/login" className="text-white underline">Sign in</Link>
            </p>
          </form>
        )}
      </div>
    </div>
  );
}
